import React from 'react'
import { Dialog, Icon, Stack, Typography } from '@mui/material'
import sxs from './_sxs'
import { ActionDialogProps } from './_props'
import { msxs } from '../../../theme/_utils'
import ActionDialogButtons from './ActionDialogButtons'

const ActionDialog: React.FC<ActionDialogProps> = ({ open, onClose, title, content, saveProps, cancelProps, icon }) => {
    const buttons = [cancelProps, saveProps].filter((x) => x !== undefined)
    return (
        <Dialog open={open} onClose={onClose} sx={sxs.actionDialog}>
            <Stack alignItems="center" gap="1.5rem" sx={sxs.actionDialogContainer}>
                <Stack gap="0.25rem">
                    <Typography sx={msxs(sxs.actionDialogTextBase, sxs.actionDialogTitle)}>{title}</Typography>
                    <Typography sx={msxs(sxs.actionDialogTextBase, sxs.actionDialogContent)}>{content}</Typography>
                </Stack>
                <Stack alignItems="center" paddingY="1rem">
                    <Icon sx={sxs.actionDialogIcon}>{icon}</Icon>
                </Stack>
                {buttons && buttons.length > 0 && <ActionDialogButtons buttons={buttons} />}
            </Stack>
        </Dialog>
    )
}
export default ActionDialog
